import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Alert, Box, Icon } from '@chakra-ui/react'

import { formatDateRange, isCrossDaySelection } from '../utils/utils'

interface CrossDayAlertIProps {
  startTime: Date
  endTime: Date
}

export const CrossDayAlert = ({ startTime, endTime }: CrossDayAlertIProps) => {
  if (!startTime || !endTime || !isCrossDaySelection(startTime, endTime)) {
    return null
  }

  const { startDateStr, endDateStr } = formatDateRange(startTime, endTime)

  return (
    <Alert
      bg='#DBE9FE'
      borderRadius='10px'
      color='#1D40B0'
      mb={4}
      status='info'
    >
      <Icon
        as={HiOutlineInformationCircle}
        boxSize='20px'
        color='#1D40B0'
        mr='10px'
      />
      <Box fontSize='13px' fontWeight={400}>
        Your schedule extends from{' '}
        <Box as='span' fontWeight={500}>
          {startDateStr}
        </Box>{' '}
        to{' '}
        <Box as='span' fontWeight={500}>
          {endDateStr}
        </Box>
      </Box>
    </Alert>
  )
}
